import {useCallback, useEffect, useState} from "react";
import {
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signInWithRedirect,
  signInWithPopup
} from "firebase/auth";
import {useNavigate, useSearchParams} from "react-router";
import {dbDelete} from "../../../util/db-util";

const useSignin = () => {
  const navigate = useNavigate();

  const [queryParams] = useSearchParams();

  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [logingIn, setLogingIn] = useState(false);

  const passwordResetted = queryParams.has("reset") && queryParams.get("reset") === "1";

  const updateEmail = useCallback(e => setEmail(e.target.value), []);
  const updatePassword = useCallback(e => setPassword(e.target.value), []);

  const handleLogin = useCallback(e => {
    e.preventDefault();

    setLogingIn(true);

    signInWithEmailAndPassword(getAuth(), email, password).catch(e => {
      setLogingIn(false);

      if (e.code === "auth/user-not-found" || e.code === "auth/wrong-password") {
        setError(("error_email_password_invalid"));
      } else {
        setError(("error_while_signin"));

        console.error(e);
      }
    });
  }, [email, password]);

  const signInGoogle = useCallback(() => {
    setLogingIn(true);

    const signInFunc = process.env.REACT_APP_FIREBASE_SIGN_IN_WITH_POPUP ? signInWithPopup : signInWithRedirect;

    signInFunc(getAuth(), new GoogleAuthProvider()).catch(e => {
      console.error(e);
      setLogingIn(false);
    });
  }, []);

  useEffect(() => {
    const unsub = onAuthStateChanged(getAuth(), user => {
      if (user) {
        return navigate("/");
      } else {
        dbDelete();

        const splash = document.getElementById("splash");

        if (splash) {
          setTimeout(() => splash.remove(), 1000);
        }
      }
    });

    return () => unsub();
  }, [navigate]);

  return {
    logingIn,
    handleLogin,
    signInGoogle,
    error,
    passwordResetted,
    email,
    password,
    updateEmail,
    updatePassword
  };
}

export default useSignin;
